function getKebabCaseLocale(locale) {
  return locale.replace(/_/g, '-');
}
function getFormatDateTimeFormatter(locale, options) {
  if (!Intl) {
    return undefined;
  }
  const kebabCaseLocale = (Array.isArray(locale) ? locale : [locale]).map(getKebabCaseLocale);
  const dateTimeFormatter = new Intl.DateTimeFormat(kebabCaseLocale, options);
  return dateTimeFormatter;
}
function getDateTimeFormat(getOptions) {
  return ({
    date,
    locale,
    ...restProps
  }) => {
    const dateTimeFormat = getFormatDateTimeFormatter(locale, typeof getOptions === 'function' ? getOptions(restProps) : getOptions);
    if (!dateTimeFormat) {
      return date.toString();
    }
    return dateTimeFormat.format(date);
  };
}
const getDateOptions = ({
  dateStyle,
  timezone
}) => {
  switch (dateStyle) {
    case 'medium':
      {
        return {
          dateStyle: 'medium',
          timeZone: timezone
        };
      }
    case 'short':
      {
        return {
          dateStyle: 'short',
          timeZone: timezone
        };
      }
    default:
      {
        return {
          dateStyle: 'medium',
          timeZone: timezone
        };
      }
  }
};

/**
 * @param {Date} date The date to format.
 * @param {string} locale A string with a BCP 47 language tag, or an array of such strings.
 * @param {string} dateStyle The date formatting style to use. Possible values include: medium, short.
 * The default is medium.
 * @param {string} timezone The time zone to use. The default is the runtime's default time zone.
 */
const formatDate = getDateTimeFormat(getDateOptions);

export { getDateOptions as a, getKebabCaseLocale as b, getDateTimeFormat as c, formatDate as f, getFormatDateTimeFormatter as g };
//# sourceMappingURL=formatDate-BIw3YDwX-BIw3YDwX.js.map
